export const RealmRoles = {
    KEYCLOAK_USER_SYNC: "keycloak-sync",
    READ_ALL_USERS: "read-all-users",
    EDIT_ALL_USERS: "edit-all-users",
    READ_ALL_BUCKETS: "read-all-buckets",
    EDIT_ALL_BUCKETS: "edit-all-buckets",
    CREATE_BUCKETS: "create-buckets",
    DELETE_ALL_BUCKETS: "delete-all-buckets",
    CREATE_TASKS: "create-tasks",
    EPORT_ADMIN: "eport-admin",
    CLEANUP_E2E_RESOURCES: "cleanup-e2e-resources",
    MAIL_SEND: "mail:send",
    MAIL_OPERATE: "mail:operate",
};
export const UserGroups = {
    USER: "EPORT_USER",
    FINANCE: "EPORT_TEAM_FINANCE",
    REPAIR: "EPORT_TEAM_REPAIR",
    DAMAGE: "EPORT_TEAM_DAMAGE",
    CUSTOMER_RELATIONS: "EPORT_TEAM_CUSTOMER_RELATIONS",
    TEAM_LEAD: "EPORT_TEAM_LEAD",
    MANAGEMENT: "EPORT_MANAGEMENT",
    ADMIN: "EPORT_ADMIN",
    TESTING: "EPORT_TESTING",
};
export const PRIVILEGED_GROUPS = [UserGroups.ADMIN, UserGroups.MANAGEMENT];
